import React from 'react';
import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { minutesInHour } from 'helpers/timeConsts';

interface MinutesSelectProps {
  value: string;
  onChange: (event: SelectChangeEvent, child: React.ReactNode) => void;
}

const minutesStep = 5;
const minuteItemSteps = Array.from(
  { length: minutesInHour / minutesStep - 1 },
  (_, i) => ((i + 1) * minutesStep).toString(),
);

export default function MinutesSelect({ value, onChange }: MinutesSelectProps) {
  const { t } = useTranslation();

  return (
    <Select
      sx={{
        flexBasis: '50%',
        borderRadius: 0,
        borderTopRightRadius: '1.2rem',
        borderBottomRightRadius: '1.2rem',
      }}
      value={value}
      displayEmpty
      renderValue={(selectValue) => {
        if (selectValue === '') {
          return (
            <Typography color="text.secondary">
              {t('properties.minutes')}
            </Typography>
          );
        }
        return `${selectValue} ${t('properties.minutes')}`;
      }}
      onChange={onChange}
    >
      <MenuItem value="">
        <em>{t('general.placeholder')}</em>
      </MenuItem>
      {minuteItemSteps.map((minute) => (
        <MenuItem key={minute} value={minute}>
          {minute}
        </MenuItem>
      ))}
    </Select>
  );
}
